//LOCAL
// export const API_HOST = "localhost";
// export const API_PORT = "8308";

//DEVELOPMENT
// export const API_HOST = "192.168.1.101";
// export const API_PORT = "65003";

//PRODUCTION
export const API_HOST = "registration.elipd.org";
export const API_PORT = "442";

export const API_URL = `https://${API_HOST}:${API_PORT}/api/`;
